module.exports = __webpack_public_path__ + "bundle.1.a20af9b1357ea25c0da1.worker.js"